/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettlementDetailComponent} from './settlement-detail.component';
import {SettlementDetailHeaderComponentModule} from '../setttlement-detail-header/settlement-detail-header.component.module';
import {SettlementFooterModule} from '../settlement-footer/settlement-footer.module';
import {SettlementDetailInformationModule} from '../settlement-detail-information/settlement-detail-information.module';
import {SettlementAgreementModule} from '../settlement-agreement/settlement-agreement.module';

@NgModule({
    imports: [
        CommonModule,
        SettlementDetailHeaderComponentModule,
        SettlementDetailInformationModule,
        SettlementFooterModule,
        SettlementAgreementModule
    ],
    declarations: [SettlementDetailComponent],
    exports: [SettlementDetailComponent]
})
export class SettlementDetailModule {
}
